import $ from "jquery";

// https://coderwall.com/p/kdi8ua/calculate-width-of-text-from-a-dom-element-or-string
$.fn.textWidth = function(text, font) {
  if (!$.fn.textWidth.fakeEl) $.fn.textWidth.fakeEl = $("<span>").hide().appendTo(document.body);
  $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css("font", font || this.css("font"));
  return $.fn.textWidth.fakeEl.width();
};
